/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../apimodel.d.ts" />
/// <reference path="ivalidatorattributes.d.ts" />
/// <reference path="ivalidator.d.ts" />
/// <reference path="validateargs.ts" />
/// <reference path="../../iformscope.d.ts" />

module App.Common.Directives {
	'use strict';

	export abstract class ValidatorBase implements angular.IDirective, IValidator {

		public require = 'ng-model';

		public restrict = 'A';

		public name: string;

		public nameCamelCase = () => {return _.camelCase(this.name);};
		public link = (scope: IFormScope,
			el: angular.IAugmentedJQuery,
			attributes: Directives.IValidatorAttributes,
			controller: angular.INgModelController): any => {

			var parameter = '';
			if (el && el.attr) {
				parameter = el.attr(this.name) || '';
			}

			var args = new Directives.ValidateArgs();
			args.el = el;
			args.scope = scope;
			args.attributes = attributes;
			args.form = scope.mainForm;
			args.controller = scope.vm;
			args.parameter = parameter;

			el.data('linkedAttributes', attributes);

			var watchExpressions = this.getWatchExpressions(args);

			if (watchExpressions.length) {
				_(watchExpressions)
					.forEach((expression) => {
						scope.$watch(expression,
						() => {

							if (!this.canValidate(args)) {
								return;
							}

							var isValidArgs = new ValidateArgs();
							isValidArgs.el = args.el;
							isValidArgs.scope = args.scope;
							isValidArgs.attributes = args.attributes;
							isValidArgs.form = args.form;
							isValidArgs.controller = args.controller;
							isValidArgs.parameter = args.parameter;

							controller.$setValidity(this.nameCamelCase(), this.isValid(isValidArgs));
						});
					});
			} else {
				controller.$validators[this.nameCamelCase()] = () => {

					var isValidArgs = new ValidateArgs();
					isValidArgs.el = args.el;
					isValidArgs.scope = args.scope;
					isValidArgs.attributes = args.attributes;
					isValidArgs.form = args.form;
					isValidArgs.controller = args.controller;
					isValidArgs.parameter = args.parameter;

					return this.isValid(isValidArgs);
				};
			}

		};

		public resolveMessageForElement = (el: angular.IAugmentedJQuery, errorType: string) => {

			/* NOTE: The message resolver uses a difference instance of the validator than the one attached to the element.
			It is probably possible to make it use the same instance, but for now, make no assumptions within this method
			that you can access any state data created by the link() method (hence "linkedAttributes" is attached to the
			element itself as data so that it can be accessed here) */

			const scope = el.scope() as IFormScope;
			let parameter = '';
			if (el && el.attr) {
				parameter = el.attr(_.kebabCase(errorType)) || '';
			}
			const args = new Directives.ValidateArgs();
			args.el = el;
			args.scope = scope;
			args.form = scope ? scope.mainForm : undefined;
			args.controller = scope ? scope.vm : undefined;
			args.parameter = parameter;
			args.attributes = el.data('linkedAttributes');

			return this.resolveMessage(args);
		};

		// ReSharper disable once UnusedParameter
		public canValidate = (args: Directives.ValidateArgs) => {
			return true;
		};

		public isValid: (args: Directives.ValidateArgs) => boolean;

		public resolveMessage: (args: Directives.ValidateArgs) => string;

		// ReSharper disable once UnusedParameter
		public getWatchExpressions = (args: Directives.ValidateArgs): string[] => {return [];};
	}

}